"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  padding-top: 14px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledHelpText = (0, _styledComponents.default)(_UILink.default).withConfig({
  displayName: "HelpText__StyledHelpText",
  componentId: "sc-1smz3xr-0"
})(_templateObject());

var HelpText = function HelpText() {
  return _react.default.createElement(StyledHelpText, {
    external: true,
    href: "https://knowledge.hubspot.com/resources/what-should-i-do-if-hubspot-videos-are-not-playing"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "ui-addon-video-player.havingTroubleWithVideoLink"
  }));
};

var _default = HelpText;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-video-player/static-1.2019/js/components/StyledComponents/HelpText.js
// module id = 285
// module chunks = 0